import {blockContentTemplate, blockTemplate} from './block';
import {simpleBlockTemplate} from './simpleBlock';
import {imageTemplate} from './image';

export const horizontalBlock = {
  '_template': 'horizontal',
  ...blockTemplate,
  content: {
    ...blockContentTemplate,
    blocks: [
      {
        ...simpleBlockTemplate,
        box: {
          padding: {
            paddingTop: {
              xl: 0,
              xs: 0
            },
            paddingLeft: {
              xl: 0,
              xs: 0
            },
            paddingRight: {
              xl: 0,
              xs: 0
            },
            paddingBottom: {
              xl: 0,
              xs: 0
            }
          },
          margin: {
            marginRight: {
              xl: 200,
              lg: 50,
              md: 25,
              xs: 0
            },
            marginTop: {
              xs: 0
            },
            marginBottom: {
              xs: 0
            },
            marginLeft: {
              xs: 0
            }
          }
        }
      },
      {
        ...imageTemplate,
        'box': {
          'size': {
            'width': {
              'xs': 0,
              'md': 350,
              'xl': 500
            },
            'maxWidth': {
              'xl': 500
            }
          },
          margin: {
            marginTop: {
              xs: 30,
              md: 30,
            },
            marginBottom: {
              xs: 0,
              md: 0
            },
          }
        }
      },
    ]
  },

};
